import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { fmtMT } from "@/lib/mountainTime";
import { money } from "@/lib/bidCenterApi";

const left = (iso, now) => {
  const s = Math.floor((new Date(iso) - now) / 1000);
  if (s <= 0) return null;
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
  return d ? `${d}d ${h}h ${m}m` : `${h}h ${m}m ${s % 60}s`;
};

export const SoftCloseStatus = ({ a }) => {
  const sc = a.soft_close || {};
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  if (!a.closes_at) return null;
  const rem = left(a.closes_at, now);
  const x = sc.latest_extension;
  const on = sc.rules?.enabled;
  const recon = rem ? null : sc.pending_review ? `${sc.pending_review} bid(s) in Review could extend the auction — resolve before completing` : sc.reconciled ? "Final check after close done" : "Waiting for the final comment check after close";
  return (
    <div data-testid={`soft-close-${a.post_id}`} className="rounded-lg border border-stone-200 bg-stone-50 p-2 text-xs grid grid-cols-2 sm:grid-cols-4 gap-2">
      <div><p className="text-stone-500">Scheduled close</p><p data-testid={`soft-scheduled-${a.post_id}`} className="font-semibold">{fmtMT(sc.scheduled_close || a.closes_at)}</p></div>
      <div><p className="text-stone-500">Current close</p><p data-testid={`soft-current-${a.post_id}`} className={`font-semibold ${sc.extensions ? "text-[#B45309]" : ""}`}>{fmtMT(a.closes_at)}</p></div>
      <div><p className="text-stone-500 flex items-center gap-1"><Timer className="h-3 w-3" />Time remaining</p><p data-testid={`soft-remaining-${a.post_id}`} className="font-semibold tabular-nums">{rem || "Bidding closed"}</p></div>
      <div><p className="text-stone-500">Extensions</p><p data-testid={`soft-extensions-${a.post_id}`} className="font-semibold">{on ? sc.extensions || 0 : "Soft close off"}</p></div>
      {x && <p data-testid={`soft-latest-${a.post_id}`} className="col-span-2 sm:col-span-4 text-stone-600">Latest extension: {money(x.amount, null)} bid by {x.author_name || "unknown"} at {fmtMT(x.bid_time)} → close moved to {fmtMT(x.to)}</p>}
      {!x && rem && sc.pending_review > 0 && <p data-testid={`soft-pending-${a.post_id}`} className="col-span-2 sm:col-span-4 text-[#92400E] font-semibold">{sc.pending_review} bid(s) near the close are in Review and may extend the auction</p>}
      {recon && <p data-testid={`soft-recon-${a.post_id}`} className={`col-span-2 sm:col-span-4 font-semibold ${sc.pending_review || !sc.reconciled ? "text-[#92400E]" : "text-emerald-700"}`}>{recon}</p>}
    </div>
  );
};
